import React from "react";
import {BrowserRouter as Router, Route} from 'react-router-dom';
import { SkipNavLink, SkipNavContent } from "@reach/skip-nav";
import "@reach/skip-nav/styles.css";

import NavBar from "./components/NavBar";
import WorkPage from "./pages/WorkPage";
import AboutMePage from "./pages/AboutMePage";
import GroupPage from "./pages/GroupPage";
import Project from "./components/Project";

function App() {

  return (
    <Router>
    <NavBar />
    <div className="Main">
    <SkipNavLink />
      <SkipNavContent />
      <Route path="/" exact>
        <WorkPage/>
      </Route>
      <Route path="/about" exact>
        <AboutMePage />
      </Route>
      <Route path="/group/:group" exact>
        <GroupPage />
      </Route>
      <Route path="/project/:project" exact>
        <Project />
      </Route>
      </div>
    </Router>
  );
}

export default App;
